import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ServiceOffert = lazy(() => import("@/pages/offert/ServiceOffert"));

export const Route = createFileRoute("/kommersiella-solceller/offert")({
  head: () => seoHead("/kommersiella-solceller/offert"),
  component: () => <ServiceOffert service="kommersiella-solceller" />,
});
